<template>
	<payHeader :bgStatus="bgStatus"></payHeader>
	<div class="user-repwd">
		<div class="container">
			<div class="head">
				<h1>找回密码</h1>
				<ul>
					<li class="step1 active">验证账号</li>
					<li class="step2">选择找回方式</li>
					<li class="step3">填写验证码</li>
					<li class="step4">重设密码</li>
				</ul>
			</div>
			<div class="tips" style="text-align: right;">如您已更换手机号码且已遗忘密保问题，可以通过<a href="https://www.landui.com/index/user/appeal.html" style="color: #015BFE;">账号申诉</a>重置账号</div>
			<el-form :model="groupForm">
				<div v-if="!multipleFlag">
					<el-form-item v-if="loginType == 'mobile'">
						<span class="label">手机号码</span>
						<el-input v-model="groupForm.account" placeholder="手机号码" autocomplete="off" />
					</el-form-item>
					<el-form-item v-if="loginType == 'account'">
						<span class="label">账号/邮箱</span>
						<el-input v-model="groupForm.account" placeholder="用户名/邮箱" autocomplete="off" />
					</el-form-item>
					<el-form-item>
						<span class="label">验证码</span>
						<el-input v-model="groupForm.captcha_answer" autocomplete="off" />
					</el-form-item>
					<el-image :src="captchaImg" @click="captchaReload" fit="contain" alt="验证码" title="点击刷新" style="display: block; height: 80px; margin: 0 auto; cursor: pointer;" />
					<div class="other">
						<span @click="typeChange('mobile')" v-if="loginType == 'mobile'">账号或邮箱找回</span>
						<span @click="typeChange('account')" v-if="loginType == 'account'">手机号码找回</span>
					</div>
				</div>
				<div class="check-account" v-else>
					<h4 class="title">选择找回账号</h4>
					<div class="li" v-for="(item, index) in multipleData" :key="index" @click="multipleChange(index,item.key)" :class="{ 'active': selectedMultiple === index }">{{item.name.username}}
						<div class="tags">
							<el-tag type="info" v-if="item.name.authstatus == 0">未认证</el-tag>
							<el-tag type="success" v-if="item.name.authstatus == 1">个人认证</el-tag>
							<el-tag type="success" v-if="item.name.authstatus == 2">企业认证</el-tag>
							<el-tag type="warning" v-if="item.name.prostatus == 1">保有产品</el-tag>
						</div>
					</div>
				</div>
				<el-form-item>
					<el-button type="primary" class="submit" @click="submitForm">{{submitBtn}}</el-button>
				</el-form-item>
			</el-form>
		</div>
	</div>
	<payFooter></payFooter>
</template>

<script setup>
	import { ref,reactive,onMounted} from 'vue';
	import { useRouter } from 'vue-router';
	import { captchaFetch,checkAccount,getuserhasproduct } from '@/api/home';
	import { payHeader,payFooter } from 'landui-ui';
	
	const bgStatus = ref(true);
	const router = useRouter();
	const multipleFlag = ref(false)
	const multipleData = ref();
	const selectedMultiple = ref();
	const loginType = ref('mobile');
	const token = ref('');
	const submitBtn = ref('验证账号');
	const captchaId = ref('');
	const captchaImg = ref('');
	const groupForm = ref({account:'',captcha_answer:''});

	const captchaChange = () => {
		captchaFetch().then((res) => {
			if (res.code == 200) {
				captchaImg.value = res.data.captcha_data;
				captchaId.value = res.data.captcha_id;
			}
		})
	}
	const captchaReload = () => {
		captchaChange()
	}
	const typeChange = (e) => {
		switch(e)
		{
			case 'account':
				loginType.value = 'mobile';
				groupForm.value.account = ''
			break;
			case 'mobile':
				loginType.value = 'account';
				groupForm.value.account = ''
			break;
		}
	};
	const multipleChange = (key,value) => {
		selectedMultiple.value = key;
		token.value = value;
	};
	const submitForm = () => {
		if (multipleFlag.value) {
			groupForm.value.type = 'token';
			groupForm.value.token = token.value;
		} else{
			groupForm.value.type = loginType.value;
		}
		groupForm.value.captcha_id = captchaId.value;
		const param = groupForm.value;
		checkAccount(param).then((res) => {
			if(res.code === 200){
				if (res.data.ischoose == '1') {
					const chooseData = res.data.unamelist;
					getuserhasproduct({'mobile':groupForm.value.account}).then((data) => {
						if (data.code == 200) {
							const result = {};
							Object.keys(data.data).forEach(key => {
							  // 检查 obj2 是否包含相同的键
							  if (Object.prototype.hasOwnProperty.call(chooseData, key)) {
							    // 创建一个新的对象来存储合并后的数据
							    const newObj = {
							      ...chooseData[key], // 复制 obj2[key] 的所有属性
							      prostatus: data.data[key] // 添加 pro 属性
							    };
							    // 将新对象添加到结果对象中
							    result[key] = newObj;
							  }
							});
							const unamelist = result;
							const transformedData = [];
							for (const [key, name] of Object.entries(unamelist)) {
							    transformedData.push({
							        key: key,
							        name: name
							    });
							}
							multipleData.value = transformedData;
							submitBtn.value = '下一步';
							multipleFlag.value = true;
						}
					})
				} else{
					localStorage.setItem('repwdData', JSON.stringify(res.data));
					router.push({ path: '/repwdSelect' })
				}
			}else{
				captchaChange();
				groupForm.value.captcha_answer = ''
			}
		})
	};
	
	onMounted(() => {
		captchaChange();
	});
	
</script>

<style lang="scss">
	.check-account{ padding: 0;width: 380px; margin: 80px auto 0;}
	.user-repwd{
		.el-form{
			width: 380px; 
			margin: 80px auto 0;
			.el-form-item{
				position: relative;
				.el-input{
					width: 100% !important;
					--el-input-height:45px;
				}
				.el-input__wrapper{padding: 1px;}
				.el-input__inner{padding-left: 100px;}
				.label{
					position: absolute;
					left: 0;
					top: 0;
					bottom: 0;
					z-index: 1;
					font-size: 13px;
					color: #999999;
					width: 90px;
					border-right: 1px solid #ddd;
					text-align: center;
					line-height: 45px;
				}
			}
			.other{
				overflow: hidden;
				margin-top:10px;
				span{cursor: pointer;color: #015bfe;}
			}
		}
		
	}
	
</style>